module.exports = __webpack_public_path__ + "img/idea-vision.05e0ded3.jpg";